var exports = {
  "kL": "x804f0401--690342--container",
  "wx": "x804f0401--690342--header",
  "AS": "x804f0401--690342--item",
  "DD": "x804f0401--690342--title",
  "Qs": "x804f0401--690342--content",
};

module.exports = exports;
